import React from "react";

import {Text} from "@pg-design/text-module";

import {ILocationGenericParagraphText} from "../../../helpers/location_generic_description/constants";
import {ParagraphSingleTextType} from "./ParagraphSingleTextType";

interface IProps {
    text: ILocationGenericParagraphText["text"];
}

export const ParagraphTextType = (props: IProps) => {
    const paragraphText = props.text;

    return Array.isArray(paragraphText) ? (
        <Text variant="body_copy_1">
            {paragraphText.map((text, index) => (
                <ParagraphSingleTextType key={index} singleText={text} />
            ))}{" "}
        </Text>
    ) : (
        <Text variant="body_copy_1">
            <ParagraphSingleTextType singleText={paragraphText} />
        </Text>
    );
};
